import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import axios from 'axios'
import store from './store'
import moment from 'moment'

Vue.config.productionTip = false


Vue.prototype.moment = moment
Vue.prototype.$http = axios

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

//javascript libraries
import '../src/js/security.js' 

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



// import Vue from "vue";
// import App from "./App";

// import Vuetify from "vuetify";
// import "vuetify/dist/vuetify.min.css";

// import router from "./router";

// Vue.use(Vuetify);

// //Vue.config.productionTip = false;

// /* eslint-disable no-new */
// new Vue({
//   el: "#app",
//   router,
//   components: { App },
//   template: "<App/>"
// });
